module.exports = __webpack_public_path__ + "img/tag-close.f8eba71a.svg";